import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import {
  UniversalNameScreenConfig,
  UniversalNameScreen,
} from '@/pages/Onboarding/Layouts/screens/UniversalNameScreen';

import { useRoleplayRoomGirlImage } from '../../hooks/useRoleplayRoomGirlImage.ts';

export const roleplayRoomsNameScreenConfig: UniversalNameScreenConfig = {
  backgroundImage: `${S3_BUCKET_URL}/own-ai-roleplay-rooms/name/background.png`,
  backgroundTheme: 'dark-solid',

  messages: {
    initial: {
      content: 'How should I call you, stranger?',
      variant: 'received',
    },
    userResponse: {
      content: '', // Will be replaced with actual userName
      variant: 'sent',
    },
    followUp: [
      {
        content: '**She looks at you**...',
        variant: 'received',
      },
      {
        content: "${userName}, I've been waiting 🫦",
        variant: 'received',
      },
    ],
  },

  buttonText: 'Keep it going',

  backToStep: 'outfit_style',
};

export const NameScreen: React.FC = () => {
  const backgroundImage = useRoleplayRoomGirlImage();

  const config: UniversalNameScreenConfig = {
    ...roleplayRoomsNameScreenConfig,
    backgroundImage,
  };

  return <UniversalNameScreen config={config} />;
};
